<script>
import PolicyReissueSuccessDialog from "@/components/app/policyReissue/PolicyReissueSuccessDialog.vue";
import PolicyReissueStartDialog from "@/components/app/policyReissue/PolicyReissueStartDialog.vue";
import reissueTypes from './reissueTypes'
import displaySettings from "@/mixin/displaySettings";
import QuestionTooltip from "@/components/app/policyReissue/components/QuestionTooltip.vue";
import FileInput from "@/components/app/policyCancel/components/FileInput.vue";
import Integer from "vuelidate/lib/validators/integer";
import {createReissue, getReissueSettings} from "@/api/reissue";


export default {
    name: "PolicyReissueDialog",
    components: {FileInput, QuestionTooltip, PolicyReissueSuccessDialog, PolicyReissueStartDialog, ...reissueTypes},
    props: ['order', 'dialogVisible'],
    mixins: [displaySettings],
    data() {
        return {
            showSuccessDialog: false,
            showFormDialog: false,
            isSubmitDisabled: true,
            dataForm: {},
            fieldsList: [ 'file', 'fileTech', 'reason', 'reasonType'],
            module: null,
            templateStatement: null,
            reasonsTypeList: [
                { name: 'Номер авто', id: 1, key: 1 },
                { name: 'VIN-код', id: 2, key: 2 },
                { name: 'Дані клієнта', id: 3, key: 3 }
            ],
        }
    },
    watch: {
        dialogVisible(val) {
            if(val) {
                this.getModule(this.order.moduleId)
            }
        }
    },
    computed: {
        reissueBlock() {
            if (this.module) {
                switch (this.module.name) {
                    case 'vuso': //10: //vuso // return 'VusoPolicyCancel';
                    case 'utsk'://17://utsk
                    case 'usg': //9: //usg
                    case 'brock': //12://brock
                    case 'euroins'://20: //euroins
                    case 'knajza'://15 knajza
                    case 'tas'://11: //tas
                    case 'etc'://24: //etc
                        return 'StandardPolicyReissue';
                    case 'oranta'://18: //oranta
                        return 'OrantaPolicyReissue';
                    case 'ingo'://22: //ingo
                        return 'IngoPolicyReissue';
                    case 'inter-polis'://19: //inter-polis
                        return 'InterPolisPolicyReissue';
                    case 'eia'://23: //eia
                        return 'EsaPolisPolicyReissue';
                    default:
                        return 'StatementPolicyReissue';
                }
            } else {
                return null;
            }
        },
        reissueAdditionalFields() {
            if (this.module) {
                switch (this.module.name) {
                    case 'ingo'://22: //ingo
                    case 'ingo-new'://29: //ingo-new
                    case 'inter-polis'://19: //inter-polis
                    case 'eia'://23: //eia
                        return 'file';
                    case 'oranta'://18: //oranta
                        return 'email';
                    default:
                        return null;
                }
            } else {
                return null;
            }
        },
        reissueTemplate() {
            if (this.module) {
                switch (this.module.name) {
                    case 'ingo'://22: //ingo
                    case 'ingo-new'://29: //ingo-new
                    case 'inter-polis'://19: //inter-polis
                    case 'eia'://23: //eia
                        return true;
                    default:
                        return false;
                }
            } else {
                return null;
            }
        },
    },
    created() {

    },
    methods: {
        getModule(id) {
            //TODO axios move to api directory
            axios.get('/api/modules/' + id).then(response => {
                this.module = response.data;
            })
        },
        getReissueSettingTemplate() {
            getReissueSettings(this.order.typeId, this.order.moduleId, this.dataForm).then(response => {
                if (response.data.data) {
                    this.templateStatement = response.data.data;
                }
            });
        },
        policyReissueApprove() {
            this.isSubmitDisabled = true;
            createReissue(this.order.id, this.dataForm).then(response => {
                this.order.reissueStatus = 'pending';
                this.$emit('update:dialogVisible', false);
                this.$emit('update:order', this.order);
                this.showSuccessDialog = true;
            })
        },
        closeModal() {
            this.dataForm = {};
            this.$emit('update:dialogVisible', false);
        },
        checkFormComplete(formValues) {
            const additionalField = this.reissueAdditionalFields;

            // обязательные поля
            const baseFieldsComplete =
                formValues.reason !== undefined && formValues.reason !== null &&
                formValues.reasonType !== undefined && formValues.reasonType !== null &&
                formValues.fileTech !== undefined && formValues.fileTech !== null;

            // Доп. поле, смотря какой модуль
            const additionalFieldComplete = additionalField
                ? formValues[additionalField] !== undefined && formValues[additionalField] !== null
                : true;

            // let additionalFieldsComplete = true;
            // if (Array.isArray(requiredFields)) {
            //     additionalFieldsComplete = requiredFields.every(field => {
            //         const value = formValues[field];
            //         return value !== undefined && value !== null && value !== '';
            //     });
            // }

          //  return baseFieldsComplete && additionalFieldsComplete;

            this.isSubmitDisabled = !(baseFieldsComplete && additionalFieldComplete);

        }
    },
}
</script>

<template>
    <div class="policy-reissue">

        <el-dialog
            :width="isMobile ? '100%' : '20%'"
            :visible.sync="dialogVisible"
            :before-close="closeModal"
            :show-close="false"
            :destroy-on-close="true"
            ref="dialog"
            center
            top="15vh"
            custom-class="p-4"
        >
            <question-tooltip>
                <div class="mt-2">
                    <p>Особливості переоформлення договорів страхування:</p>
                    <ol class="list-left" style="text-align: left; font-size: 12px;">
                        <li>Дозволено змінювати:
                            <ul>
                                <li>Номер авто.</li>
                                <li>VIN-код.</li>
                                <li>Одне з полів даних про клієнта (не у всіх СК).</li>
                            </ul>
                        </li>
                        <li>Не можна змінювати:
                            <ul>
                                <li>Марку/модель авто, рік випуску.</li>
                                <li>Місце реєстрації власника. У разі зміни реєстрації зверніться в чат Viber для консультації щодо довгострокового розірвання.</li>
                            </ul>
                        </li>
                        <li>Потрібно прикріпити заяву на переоформлення:
                            <ul>
                                <li>Інтер-Поліс, ІНГО, ЄСА.</li>
                            </ul>
                        </li>
                    </ol>
                </div>
            </question-tooltip>
            <div class="standart-component">
                <standard-policy-reissue
                    v-if="reissueBlock"
                    v-model="dataForm"
                    :company-name="order.companyInfo.publicName"
                    :module-id="order.moduleId"
                    :product-id="order.typeId"
                    :reason-types="reasonsTypeList"
                    :additional-fields="reissueAdditionalFields"
                    :template-statement-path="reissueTemplate"
                    @is-fill-form="checkFormComplete"
                />
            </div>
<!--            <div v-loading="!!!reissueBlock">-->
<!--                <component-->
<!--                    v-if="reissueBlock"-->
<!--                    v-model="dataForm"-->
<!--                    :is="reissueBlock"-->
<!--                    :company-name="order.companyInfo.publicName"-->
<!--                    :module-id="order.moduleId"-->
<!--                    @is-fill-form="checkFormComplete"-->
<!--                />-->
<!--            </div>-->
            <div slot="footer">
                <el-row>
                    <el-col>
                        <div class="title mb-4">Ви впевнені, що бажаєте переоформити поліс?</div>
                    </el-col>
                    <el-col class="mb-4">
                        <el-button
                            :disabled="isSubmitDisabled"
                            type="primary"
                            class="w-100"
                            @click="policyReissueApprove"
                        >
                            Так, подати поліс на переоформлення.
                        </el-button>
                    </el-col>
                    <el-col>
                        <el-button class="cancel w-100" @click="closeModal">Ні, я хочу залишити поліс діючим.
                        </el-button>
                    </el-col>
                </el-row>
            </div>
        </el-dialog>

        <policy-reissue-success-dialog :dialog-visible.sync="showSuccessDialog"/>
    </div>
</template>

<style lang="scss">
@import "./styles/policy-reissue.scss";
</style>
